import { render } from "./FarmLife.vue?vue&type=template&id=ea1feb08"
import script from "./FarmLife.vue?vue&type=script&lang=js"
export * from "./FarmLife.vue?vue&type=script&lang=js"

import "./FarmLife.vue?vue&type=style&index=0&id=ea1feb08&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__